import { useEffect, useState } from 'react';
import { useAuth, API_URL } from '../contexts/AuthContext';
import { useNotificationPopups } from '../hooks/useNotificationPopups';

// App-wide native-style notification pop-ups. Renders nothing; drives sonner toasts.
export default function NotificationPopups() {
  const { user } = useAuth();
  const role = user?.role;

  // Parent portal uses its own JWT (parent_token) and does not populate AuthContext.user,
  // so detect the parent session directly from localStorage (reactively).
  const [hasParent, setHasParent] = useState(() => !!localStorage.getItem('parent_token'));
  useEffect(() => {
    const check = () => setHasParent(!!localStorage.getItem('parent_token'));
    check();
    const iv = setInterval(check, 3000);
    window.addEventListener('storage', check);
    return () => { clearInterval(iv); window.removeEventListener('storage', check); };
  }, []);

  // Admin / staff dashboard alerts (leads, payments, staff extra-half approvals, etc.)
  useNotificationPopups({
    enabled: role === 'admin',
    listUrl: `${API_URL}/admin/notifications`,
    markSeenUrl: `${API_URL}/admin/notifications/mark-seen`,
  });

  // Member / parent portal notifications
  useNotificationPopups({
    enabled: role !== 'admin' && hasParent,
    listUrl: `${API_URL}/parent/notifications`,
    markSeenUrl: `${API_URL}/parent/notifications/mark-seen`,
  });

  return null;
}
